import React from 'react';

import { SegmentedControl, SegmentedControlItem } from '@mantine/core';

import styles from './SwitchTabs.module.scss';

export interface SwitchTabsProps {
  options: Array<{
    id: string;
    label: string;
    icon?: React.ReactNode;
    disabled?: boolean;
  }>;
  value: string;
  onChange?: (value: any) => void;
  name?: string;
  disabled?: boolean;
  className?: string;
}

export const SwitchTabs: React.FC<SwitchTabsProps> = ({
  options,
  value,
  onChange,
  name,
  disabled = false,
  className
}) => {
  const data: SegmentedControlItem[] = options.map((option) => ({
    value: option.id,
    label: (
      <div className={styles.tabContent}>
        {option.icon && <span className={styles.tabIcon}>{option.icon}</span>}
        <span className={styles.tabLabel}>{option.label}</span>
      </div>
    ),
    disabled: option.disabled
  }));

  return (
    <SegmentedControl
      data={data}
      value={value}
      onChange={onChange}
      disabled={disabled}
      name={name}
      withItemsBorders={false}
      classNames={{
        root: `${styles.switchTabs} ${className || ''}`,
        control: styles.control,
        indicator: styles.indicator,
        label: styles.label,
        input: styles.input
      }}
      fullWidth
      aria-label={name || 'Switch Tabs'}
    />
  );
};

export default SwitchTabs;
